import { useCheckoutSession } from "./CheckoutSession";
import { PhoneAuthentication } from "./PhoneAuthentication";

type Props = {
  eventId: string;
  onComplete: () => void | Promise<void>;
  onBack?: () => void;
};

export function CheckoutPhoneAuthentication({ eventId, onComplete, onBack }: Props) {
  const checkout = useCheckoutSession();
  return (
    <PhoneAuthentication
      eventId={eventId}
      description="We’ll send your tickets here."
      draft={checkout.draft}
      update={checkout.update}
      canContinue={checkout.canContinue}
      onBack={onBack ?? (() => checkout.setStep("tickets"))}
      onComplete={onComplete}
    />
  );
}
